import {WorkspaceBannerType} from '../../components/WorkspaceBanners/types';
import {makeTrackEvent} from './makeTrackEvent';

type Event = 'Banner displayed' | 'Banner dismissed';
type TrackedProperties = {
  bannerType: WorkspaceBannerType;
  event: Event;
  additionalProperties?: Record<string, any>;
};

export const trackWorkspaceBanners = makeTrackEvent<
  TrackedProperties,
  {
    bannerType: {
      description: 'which banner';
      exampleValues: ['panel-auto-gen-info'];
    };
    event: {
      description: 'what happened';
      exampleValues: ['Banner displayed', 'Banner dismissed'];
    };
    _description: 'Tracks events related to workspace banners';
    _location: 'Workspace banners are displayed at the top of the panel bank above the panel search box';
    _motivation: 'To track usage';
  }
>('Workspace banners');
